import React, { Component } from "react";
import { CSVLink } from "react-csv";
import { dataUser } from "../Helpers/util";
const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class ParkingReqSort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: false,
      parkingData: props.parkingInfo,
      userRole: (UserObj && UserObj.role_data) ? UserObj.role_data : [],
    };
    this.handelDropdown = this.handelDropdown.bind(this);
  }

  componentWillReceiveProps() {
    this.setState({
      parkingData: this.props.parkingInfo
    })
  }

  componentDidMount() {
    this.refreshPage();
  }

  handelDropdown() {
    this.setState({
      dropdown: !this.state.dropdown,
    });
  }

  setSelectSort = (e) => {
    const params = { sort_by: e.target.value };
    this.props.sendSortToParent(params);
  };

  refreshPage = () => {
    this.props.sendSortToParent(null);
  };

  render() {
    const userRole = this.state.userRole.find(element => element.service_id == '15')
    const headers = [
      { label: "Id", key: "rec_id" },
      { label: "Email", key: "email" },
      { label: "Phone", key: "phone" },
      { label: "Status", key: "status" },
      { label: "User Id", key: "user_id" },
      { label: "User Name", key: "user_name" },
      { label: "Vehicle Number", key: "vehicle_number" },
      { label: "Vehicle RC", key: "vehicle_rc" },
      { label: "Vehicle Wheelers", key: "wheeler" },
    ];

    return (
      <>
        <div
          className={this.state.dropdown ? "removeclass show" : "removeclas"}
          onClick={this.handelDropdown}
        ></div>
        <div className="barIcon" onClick={this.handelDropdown}>
          <img src="img/bars.svg" />
          <div className={this.state.dropdown ? "barForm show" : "barForm"}>
            <ul>
              <li className="barformSub">
                <img src="img/submen1.svg" /> Sort by
                <div className="barsubList">
                  <ul>
                    <li>
                      {" "}
                      <input
                        type="text"
                        name="vehicle_number"
                        value="vehicle_number"
                        onClick={this.setSelectSort}
                      />{" "}
                      Vehicle Number
                    </li>
                    <li>
                      <input
                        type="text"
                        name="status"
                        value="status"
                        onClick={this.setSelectSort}
                      />
                      Status{" "}
                    </li>
                  </ul>
                </div>
              </li>
              {/* {(userRole && userRole.role_for_write == '1' ? true : false) ? */}
              <li>
                <CSVLink
                  filename={"Parking.csv"}
                  data={this.state.parkingData ? this.state.parkingData : ""}
                  headers={headers}
                  className="innertext"
                >
                  <img src="img/submen3.svg" /> Export Parking Data
                </CSVLink>
              </li>
              {/* : ""} */}
              <li onClick={this.refreshPage}>
                <img src="img/submen4.svg" /> Refresh List
              </li>
            </ul>
          </div>
        </div>
      </>
    );
  }
}

export default ParkingReqSort;
